import LRUCache from 'lru-cache';

const CACHE_TTL_SECONDS = 120;

export function createCache<K, V>(max: number, ttl = CACHE_TTL_SECONDS): LRUCache<K, V> {
  return new LRUCache({ max, ttl: ttl * 1000 });
}
